/* ============================================================
   store-custom.js
   Handles: gallery, ask panel, price tiers, accordions,
   ingredient tabs, clinician "show more", video cards.
   Safe to run more than once (theme editor re-renders sections).
   ============================================================ */

(function () {
  'use strict';

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var slides = all('.sc-gallery__slide', root);
    var thumbs = all('.sc-gallery__thumb', root);
    if (!slides.length) return;
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = root.querySelector('.sc-gallery__nav--prev');
    var next = root.querySelector('.sc-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    show(0);
  }

  /* ---------- Ask / quick-answer panel ---------- */
  function initAsk(root) {
    all('.sc-ask', root).forEach(function (panel) {
      var chips = all('.sc-ask__chip', panel);
      var answers = all('.sc-ask__answer', panel);
      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () {
          var open = chip.classList.contains('is-active');
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          answers.forEach(function (a) { a.classList.remove('is-active'); });
          if (!open) {
            chip.classList.add('is-active');
            if (answers[i]) answers[i].classList.add('is-active');
          }
        });
      });
      var tabs = all('.sc-ask__tab', panel);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Price tiers + subscribe toggle ---------- */
  function initTiers(root) {
    all('.sc-buy-form', root).forEach(function (form) {
      var tiers = all('.sc-tier', form);
      var idInput = form.querySelector('.sc-variant-input');
      var planInput = form.querySelector('.sc-plan-input');
      var subToggle = form.querySelector('.sc-sub-toggle');

      function sync() {
        var active = form.querySelector('.sc-tier input:checked');
        if (!active) return;
        var tier = active.closest('.sc-tier');
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        if (idInput) idInput.value = active.value;
        if (planInput) {
          var plan = tier.getAttribute('data-selling-plan') || '';
          planInput.value = (subToggle && subToggle.checked && plan) ? plan : '';
        }
      }

      tiers.forEach(function (t) {
        var input = t.querySelector('input');
        if (input) input.addEventListener('change', sync);
      });
      if (subToggle) subToggle.addEventListener('change', sync);
      sync();
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions(root) {
    all('.sc-acc__btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.sc-acc__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sign = btn.querySelector('.sc-acc__sign');
        if (sign) sign.textContent = open ? '\u2212' : '+';
      });
    });
  }

  /* ---------- Ingredient tabs ---------- */
  function initIngredientTabs(root) {
    all('[data-ing-tabs]', root).forEach(function (wrap) {
      var tabs = all('.sc-ing__tab', wrap);
      var cards = all('.sc-ing__card', wrap);
      function apply(group) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.group === group); });
        cards.forEach(function (c) { c.style.display = (group === 'all' || c.dataset.group === group) ? '' : 'none'; });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { apply(t.dataset.group); }); });
      if (tabs[0]) apply(tabs[0].dataset.group);
    });
  }

  /* ---------- Clinician show more ---------- */
  function initShowMore(root) {
    all('.sc-clin__more', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement.querySelector('.sc-clin__body');
        if (!body) return;
        var clamped = body.classList.toggle('is-clamped');
        btn.textContent = clamped ? btn.dataset.more : btn.dataset.less;
      });
    });
  }

  /* ---------- Video cards ---------- */
  function initVideos(root) {
    all('.sc-vcard__play', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.sc-vcard');
        var video = card.querySelector('video');
        var frame = card.querySelector('iframe');
        card.classList.add('is-playing');
        if (video) { video.controls = true; video.play(); }
        if (frame) {
          var src = frame.getAttribute('data-src');
          if (src) frame.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
        }
      });
    });
  }

  function boot(root) {
    root = root || document;
    initGallery(root);
    initAsk(root);
    initTiers(root);
    initAccordions(root);
    initIngredientTabs(root);
    initShowMore(root);
    initVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Re-init when a section is edited in the theme customizer */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
